import { Component, ElementRef, EventEmitter, NgZone, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PromoterGooglePlaceModel } from 'src/app/interfaces/promoter/PromoterGooglePlace.model';
import { ApiService } from 'src/app/_services/api.service';
import { CompanyRequest } from 'src/app/_models/Company/CompanyModel';

@Component({
  selector: 'app-company-credentials',
  templateUrl: './company-credentials.component.html',
  styleUrls: ['./company-credentials.component.scss']
})
export class CompanyCredentialsComponent implements OnInit {
  @ViewChild('search') searchElementRef: ElementRef;

  public spinner: boolean = false;
  public companyId: string = "";
  public companyUpdateInfo: CompanyRequest;
  public companyAdress: PromoterGooglePlaceModel = {};
  public list: any[];
  public languageId: number;
  public contires: Array<any> = new Array<any>();
  public selectedCountry: any;
  public changedCountryCode = new EventEmitter<string>();

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private ngZone: NgZone,
    private apiService: ApiService,
  ) {
    if (this.config.data != undefined && this.config.data.companyId) {
      this.companyId = this.config.data.companyId;
    }
    this.list = [
      { name: 'Cafes and boutiques', checked: false, id: 1 },
      { name: 'Pubs and bars', checked: false, id: 2 },
      { name: 'Restaurants and bistros', checked: false, id: 3 },
      { name: 'Clubs and discotheques ', checked: false, id: 4 },
      // { name:'Halls and galeries', checked: false, id: 5 },
      { name: 'Private and premium clubs', checked: false, id: 6 },
      // { name:'Arenas and malls', checked: false, id: 7 },
      // { name:'Public spaces', checked: false, id: 8 }
    ]
    this.companyUpdateInfo = new CompanyRequest();
  }

  ngOnInit(): void {
    this.apiService.getallcountrynames().subscribe(result => {
      this.contires = result;
    });
  }

  ngAfterViewInit() {
    this.findAddress();
  }

  save() {
    this.companyUpdateInfo.id = this.companyId;
    this.companyUpdateInfo.address = this.companyAdress.placeAddress;
    this.companyUpdateInfo.city = this.companyAdress.placeCity;
    this.companyUpdateInfo.postalCode = this.companyAdress.placePostalCode;
    this.companyUpdateInfo.countryCode = this.companyAdress.placeCountryCode;
    if (this.companyUpdateInfo.address != undefined) {
      this.spinner = true;
      this.apiService.updateCompany(this.companyUpdateInfo).subscribe((response) => {
        if (response) {
          this.spinner = false;
          this.ref.close(true);
        }
      }, (error) => {
        this.spinner = false;
        this.ref.close(false);
      });
    }
  }

  cancel() {
    this.ref.close(false);
  }

  openTermsAndConditions() { }

  selectedCountryCode(selectedCountry: any) {
    this.companyUpdateInfo.address = "";
    this.companyAdress = {};
    this.changedCountryCode.emit(selectedCountry.countryCode);
  }
  changeAddress(event: any) {
    this.companyAdress = {};
  }
  findAddress() {
    // TODO: need to load Google Maps API first
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"],
      });
      this.changedCountryCode.subscribe((selectedCountryCode) => {
        if (selectedCountryCode) {
          autocomplete.setComponentRestrictions({ country: selectedCountryCode })
          autocomplete.addListener("place_changed", () => {
            this.ngZone.run(() => {
              let place: google.maps.places.PlaceResult = autocomplete.getPlace();
              this.companyAdress.placeID = place.place_id;
              this.companyAdress.placeName = place.name;
              this.companyAdress.placeAddress = place.formatted_address;
              for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
                const componentType = component.types[0];
                switch (componentType) {
                  case "postal_code": {
                    this.companyAdress.placePostalCode = `${component.long_name}`;
                    break;
                  }
                  case "locality":
                    this.companyAdress.placeCity = `${component.short_name}`
                    break;
                  case "country":
                    this.companyAdress.placeCountry = `${component.long_name}`
                    this.companyAdress.placeCountryCode = `${component.short_name}`
                    break;
                }
              }
            });
          });
        }
      });
  }

  isEmptyObject(obj: any) {
    return (obj && (Object.keys(obj).length === 0));
  }

  getLanguageId() {
    if (window.localStorage.getItem('languageId') != null && window.localStorage.getItem('languageId')) {
      return window.localStorage.getItem('languageId');
    } else {
      return "1";
    }
  }
}
